import Lightning from "@lightningjs/sdk/src/Lightning";
import DialogBox from "./dialog-box";
import { IDialogueButton, IDialogueInfo } from "../../lib/interfaces";
import { AppData, Router } from "@lightningjs/sdk";
import { Button } from "@lightningjs/ui-components";
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from "../../lib/enum";
import { AppSetup } from "../../lib/app-setup";


export interface DialogWidgetTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class DialogWidget
  extends Lightning.Component<DialogWidgetTemplateSpec>
  implements Lightning.Component<DialogWidgetTemplateSpec>
{

  focusedIndex = 0
  dialogStack: any[] = []
  static override _template(): Lightning.Component.Template<DialogWidgetTemplateSpec> {
    return {
      w: 0,
      h: 0,
      collision: true,
      zIndex: 701,
      flex: { direction: 'column', alignItems: 'center', justifyContent: 'center' },
      Dialog: undefined,
      visible: false,
    }
  }

  override _onActivated() {
    //this.showNotification('Successfully added to Queue List !')
  }

  override _init() {
    //
  }

  override _focus() {
    // console.log('_focus: ', this._getFocused())
  }

  override _getFocused() {
    return this.tag('Dialog')!
  }

  removeOldPopup(dialogInfo: IDialogueInfo) {
    const index = this.dialogStack.findIndex(currdialogInfo => currdialogInfo.type === dialogInfo.type)
    if (index > 0 && this.dialogStack[index].type == (DIALOG_TYPE.APP_EXIT_BOX)) {
      this.dialogStack.splice(index,1)
    }
  }

  checkAndPushDialogInfo(dialogInfo: IDialogueInfo) {
    this.removeOldPopup(dialogInfo)
    this.dialogStack.push(dialogInfo)
  }

  showDialog(dialogInfo: IDialogueInfo) {
    this.patch({
      w:1920,
      h:1080,
      visible: true,
    })
    this.checkAndPushDialogInfo(dialogInfo)
    this._updatePopup()
  }

  _updatePopup() {
    this.patch({ Dialog: undefined })
    if (this.dialogStack.length > 0) {
      Promise.resolve().then(() => {
        this.patch({
          Dialog: {
            type: DialogBox,
            collision: true,
            zIndex: 702,
            msg: this.dialogStack[this.dialogStack.length - 1]
          }
        })
        this._refocus()
      })
    } else {
      Router.focusPage()
    }
  }

  hideDialog() {
    this.dialogStack.pop()
    this._updatePopup()
    this.patch({
      w:0,
      h:0,
      visible: false,
    })
  }

  $handleDialogueButtons(dialogueInfo: IDialogueInfo, selectedButton: IDialogueButton) {
    this.hideDialog()
    if (dialogueInfo.type == DIALOG_TYPE.APP_EXIT_BOX || DIALOG_TYPE.NETWORK_BOX) {
      //console.log('dialogueInfo.callback: ' + dialogueInfo.callback)
      if (dialogueInfo.callback) {
        dialogueInfo.callback(selectedButton, dialogueInfo)
      }
    }
  }
}
